import { render, staticRenderFns } from "./deanInputSelectMulti.vue?vue&type=template&id=daf6c924&scoped=true"
import script from "./deanInputSelectMulti.vue?vue&type=script&lang=ts"
export * from "./deanInputSelectMulti.vue?vue&type=script&lang=ts"
import style0 from "./deanInputSelectMulti.vue?vue&type=style&index=0&id=daf6c924&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daf6c924",
  null
  
)

export default component.exports